export default "__VITE_ASSET__wAyR6r0e__"